import { mapKeys, Dictionary } from 'lodash';

export function generateDataAttributes(
  data: Record<string, string> | null | undefined,
): Dictionary<string> | null {
  if (!data) return null;
  return mapKeys(data, (_value, key) => `data-${key}`);
}
